<template>
  <b-modal centered :id="dialogId" modal-class="overflow-hidden" size="lg" static hide-footer>
    <template #modal-header="{ close }">
      <h5 class="modal-title">Bảng chọn Merchant</h5>
      <button type="button" class="close" @click="close">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <div class="form-group row">
      <label class="col-sm-3 col-form-label">Tên MC/Email/Số điện thoại</label>
      <div class="col-sm-7">
        <input
          type="text"
          v-model.trim="search.textSearch"
          class="form-control"
          @keyup.enter="getListMerchant()"
        />
      </div>
      <button class="btn btn-success btn-primary" @click="getListMerchant()">Tìm kiếm</button>
    </div>
    <b-table
      ref="select-merchant-table"
      style="max-height: 55vh"
      :fields="fields"
      :busy.sync="loading"
      sticky-header
      responsive
      hover
      bordered
      selectable
      select-mode="single"
      :items="dataListMC"
      @row-selected="onRowSelected"
    >
      <template #cell(selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
      <template #table-busy>
        <div class="my-2 text-center">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>
      <template #cell(Merchant)="data">
        <b>Người đại diện:</b> {{ data.item.customerName }}<br />
        <b>MC:</b> {{ data.item.merchantName }}<br />
        <b>Email:</b> {{ data.item.email }} <br />
        <!-- <b>SĐT:</b> {{ data.item.mobile }} -->
      </template>
      <template #cell(region)="data">
        {{ data.item.regionId | transfromData(dataConfigRegion) }} -
        {{ data.item.city }}
      </template>
    </b-table>
    <div class="pagination-bottom">
      <b-pagination
        v-model="search.page"
        :total-rows="total"
        :per-page="search.limit"
        class="fl-right mr-2"
      ></b-pagination>
    </div>
  </b-modal>
</template>

<script>
  import { MerchantService } from '@/services/merchant.service'
  import { StaffService } from '@/services/staff.service'
  export default {
    props: {
      dialogId: {
        type: String,
        default: 'select-merchant-dialog',
      },
    },
    data() {
      return {
        fields: [
          {
            key: 'selected',
            label: '',
            tdClass: 'text-center',
            thStyle: 'min-width: 30px',
          },
          'Merchant',
          { key: 'region', label: 'Vùng kinh doanh' },
        ],
        dataListMC: [],
        search: {
          limit: 50,
          page: 1,
          status: 'CURRENT_MERCHANT',
          userId: JSON.parse(localStorage.getItem('userData')).userId,
        },
        loading: false,
        total: 0,
        disabled: true,
        selectedMC: [],
        dataConfigRegion: [],
        selected: null,
      }
    },

    watch: {
      'search.page': function () {
        this.getListMerchant()
      },
    },

    created() {
      this.getRegions()
      this.getListMerchant()
    },

    methods: {
      onRowSelected(items) {
        this.disabled = !(items.length > 0)
        this.selected = items.length > 0 ? items[0] : null
        this.$emit('selectMerchant', this.selected)
        this.$bvModal.hide(this.dialogId)
      },
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegion = data.data.map(e => ({
            id: e.id,
            text: e.name,
          }))
        }
      },
      async getListMerchant() {
        try {
          this.loading = true
          if (this.search.textSearch === '') delete this.search.textSearch
          const response = await MerchantService.getDataMerchant(this.search)
          if (response.code === 1000) {
            this.dataListMC = response.data
            this.total = response.meta?.pagination?.total ?? 0
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>

<style scoped>
  ::v-deep .b-table tbody > tr {
    cursor: pointer;
  }
</style>
